export default function NotAuthorizedPage() {
  return (
    <div style={{ padding: "2rem", textAlign: "center", color: "orange" }}>
      <h1>Not Authorized</h1>
      <p>You don’t have permission to access this area.</p>
    </div>
  );
}
